import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ToolBar from '@/components/bussiness/ToolBar.vue'
import { ref, computed, watch } from 'vue'
import { oemUrl } from './const'
import AdditionCom from './addition/index.vue'
import micro from '@micro-zoe/micro-app'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'product'],
  emits: ['update:visible', 'updateNum'],
  setup(__props, { emit }) {

const props = __props



const sonData: any = ref({})
const url = oemUrl + 'oem/utility/Calculator/Unlogin'
const title = ref('')
const additionComRef = ref()
const onChange = (data: any) => {
  sonData.value = data.detail.data?.data
  const { type, addition, noAdditionalFlag, isGroup, noSpot, product } = data.detail.data?.data
  if (['AdtOrder', 'DeliAdt'].includes(type)) {
    additionComRef.value.open({
      type,
      addition,
      noAdditionalFlag,
      isGroup,
      noSpot,
      product
    })
  }
}
const store = useStore()
const token = computed(() => store.getters.token)
// debugger
store.dispatch('route/changeToken', token.value)
watch(
  token,
  (v) => {
    // 若是token不存在直接重定向
    if (v) {
      window.location.href = '/'
    }
  },
  { immediate: true }
)

const close = () => {
  emit('update:visible', false)
}

const updateNum = () => {
  props.product.skuList.forEach((v: any) => {
    emit('updateNum', v)
  })
}
const handleAdt = (addition: any) => {
  micro.setData('my-app', {
    data: {
      addition: addition,
      type: sonData.value.type
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_micro_app = _resolveComponent("micro-app")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ToolBar),
    _createVNode(_component_micro_app, {
      name: "my-app",
      url: url,
      onDatachange: onChange,
      destroy: ""
    }),
    _createVNode(AdditionCom, {
      ref: (_value, _refs) => {
        _refs['additionComRef'] = _value
        additionComRef.value = _value
      },
      onChange: handleAdt
    }, null, 512)
  ], 64))
}
}

})